<template>
	<ul>
		<li
			v-for="(item, i) in list"
			:key="i"
			:class="[
				{
					'mt-200': i !== 0,
					'bb border-color-reversed': i !== list.length - 1
				}
			]"
		>
			<h3 class="subheading text-color-white">
				{{ item.heading }}
			</h3>
			<p
				:class="[
					'body-md text-color-white mt-50',
					{
						'mb-200': i !== list.length - 1
					}
				]"
				>{{ item.description }}</p
			>
		</li>
	</ul>
</template>
<script setup lang="ts">
const list: Array<{ heading: string; description: string }> = [
	{
		heading: 'Direct-access platform',
		description:
			'We offer direct access to our funds through our online platform, with no middlemen or brokers required.'
	},
	{
		heading: 'Investor servicing and fund management',
		description:
			'Cornice™, our internal software system, enables us to handle tax reporting, fund administration, and transaction management—all at a fraction of the cost of traditional firms.'
	},
	{
		heading: 'Performance-enhancing asset operations',
		description:
			'We’ve developed data infrastructure tools, like Basis™, to unlock real-time information, automate reporting, and improve performance across our 20,000+ units.'
	}
];
</script>
